import * as React from "react";
import type { SVGProps } from "react";
const SvgNote02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.586 16.818c-.294-.64-1.497-1.574-1.796-1.709a3.7 3.7 0 0 0-2.266-.436 3.64 3.64 0 0 0-2.071.989 3.44 3.44 0 0 0-1.022 2.005c-.103.76.055 1.53.45 2.193a3.56 3.56 0 0 0 1.737 1.475c.73.293 1.54.345 2.304.147a3.6 3.6 0 0 0 1.921-1.242 3.4 3.4 0 0 0 .743-2.118V5.91a1 1 0 0 1 .78-.975L21.6 2.4v13.24m0 0v1.305c0 .765-.261 1.51-.743 2.117a3.6 3.6 0 0 1-1.92 1.242 3.7 3.7 0 0 1-2.305-.147 3.56 3.56 0 0 1-1.737-1.474 3.4 3.4 0 0 1-.45-2.193 3.44 3.44 0 0 1 1.022-2.006 3.64 3.64 0 0 1 2.071-.989c.784-.1 1.58.054 2.265.437.3.134 1.503 1.068 1.797 1.708"
    />
  </svg>
);
export default SvgNote02;
